import React from 'react';
import { Form, Input, Modal, Switch, Typography } from 'antd';

const { Text } = Typography;

const SampleDataModal = ({ open, onCancel, onSubmit, loading }) => {
  const [form] = Form.useForm();

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      await onSubmit?.(values);
      form.resetFields();
    } catch (error) {
      // Validation errors are shown by Form.Item.
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel?.();
  };

  return (
    <Modal
      title='Tạo dữ liệu mẫu bằng AI'
      open={open}
      onOk={handleOk}
      onCancel={handleCancel}
      okText='Bắt đầu tạo'
      cancelText='Đóng'
      okButtonProps={{ loading }}
      destroyOnClose
    >
      <Form
        form={form}
        layout='vertical'
        initialValues={{
          shop_description_prompt: '',
          reset_homepage: true,
        }}
      >
        <Form.Item
          label='Mô tả shop cần tạo dữ liệu'
          name='shop_description_prompt'
          rules={[
            { required: true, message: 'Vui lòng nhập mô tả shop' },
            { min: 10, message: 'Mô tả cần tối thiểu 10 ký tự' },
          ]}
        >
          <Input.TextArea
            rows={4}
            placeholder='Ví dụ: Shop bán quần áo chuyên thời trang nữ trẻ trung, giá tầm trung, ưu tiên đồ đi làm và đi chơi.'
          />
        </Form.Item>

        <Form.Item label='Thiết lập lại trang chủ theo mẫu' name='reset_homepage' valuePropName='checked'>
          <Switch checkedChildren='Bật' unCheckedChildren='Tắt' />
        </Form.Item>

        <Text type='secondary'>
          Hệ thống sẽ tạo 20 sản phẩm mẫu, 5 tag, 5 category, 5 product collection và tự sinh mô tả shop.
        </Text>
      </Form>
    </Modal>
  );
};

export default SampleDataModal;
